import React from 'react'
import PropTypes from 'prop-types'
import { Modal } from 'antd'

import AddSquad from '../../dataDisplay/AddSquad'
import './../../ui.style.scss'

class AddSquadModal extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      disable: true
    }
  }

  resetState = () => {
    const state = {
      newTitle: undefined,
      newMailId: undefined,
      disable: true
    }
    this.setState({ ...state })
  }

  render () {
    const { visible, handleCancel, title, okText, project } = this.props
    return (

      <Modal
        className='general-modal add-squad-modal'
        visible={visible}
        closable={false}
        title={title}
        // okButtonProps={{ disabled: !(newTitle), loading: loading }}
        // onOk={this.handleSubmit}
        onCancel={handleCancel}
        okText={okText}
        cancelText='Back'
        // afterClose={this.resetState}
        width='1118px'
        centered
        destroyOnClose
        maskClosable={false}
      >
        <AddSquad project={project} />
      </Modal>
    )
  }
}

AddSquadModal.propTypes = {
  /** visible action of AddSquadModal. */
  visible: PropTypes.bool,
  /** handleCancel action of AddSquadModal. */
  handleCancel: PropTypes.func
}

AddSquadModal.defaultProps = {
}

export default AddSquadModal
